import React from 'react';
import styled, { css } from 'styled-components';

export type Props = {
  /** Maximum spacing between entries */
  maxGap?: string;

  /** Width of the container */
  width?: string;
};

const InputGroup: React.FCC<Props> = ({
  dataTestId,
  children,
  maxGap,
  width,
  ...rest
}) => {
  const child = React.Children.map(children, (child, index) => {
    if (index === 0) return child;

    return (
      <>
        <Gutter $maxGap={maxGap} />
        {child}
      </>
    );
  });

  return (
    <Container data-testid={dataTestId} $width={width} {...rest}>
      {child}
    </Container>
  );
};

const Container = styled.div<{ $width?: string }>(
  ({ theme, $width = 'auto' }) => css`
    display: flex;
    align-items: flex-end;
    margin: ${theme.space('s')} 0;
    width: ${$width};
  `,
);

const Gutter = styled.div<{ $maxGap?: string }>(
  ({ $maxGap }) => css`
    width: ${$maxGap ? $maxGap : '70px'};
  `,
);

export default InputGroup;
